import React, {FC} from 'react';

import {
  KnowledgeBaseComposerDropdownInsertTrackingData,
  KnowledgeBaseInsertHandler,
} from '../../../../../../libs/knowledge-base/shared/components/composerIntegration/knowledgeBaseComposerDropdown';
import {Trans} from '../../../../../../libs/shared/core/src/helpers/internationalization/react';
import {
  InterfaceEventsEnum,
  trackInterfaceEvent,
} from '../../../../../../libs/shared/core/src/services/tracking/tracking';
import {getHasPublishedExternalKnowledgeBase} from '../../../../../../libs/shared/core/src/store/data/knowledgeBases/knowledgeBasesSelectors';
import {NewPanelId} from '../../../../../../libs/shared/core/src/store/panels/panelStateBase';
import {ToolbarButton} from '../../../../../../libs/shared/ui/src/components/buttons/toolbarButton';
import {
  PopoverCoordinator,
  PopoverTransferProps,
} from '../../../../../../libs/shared/ui/src/components/popovers/popoverCoordinator';
import {UserThemeConsumer} from '../../../../../../libs/shared/ui/src/theme/userThemeConsumer';
import {useAppSelector} from '../../../../../helpers/appReduxHelpers';
import {KnowledgeBaseComposerDropdownContainer} from '../../knowledgeBase/knowledgeBaseComposerDropdownContainer';

/*
 * Props.
 */

export interface KnowledgeBaseToolbarButtonProps {
  panelId: NewPanelId;
  onKnowledgeBaseInsertContent?: KnowledgeBaseInsertHandler;
}

/*
 * Component.
 */

export const KnowledgeBaseToolbarButton: FC<KnowledgeBaseToolbarButtonProps> = (props) => {
  const {onKnowledgeBaseInsertContent} = props;
  const hasPublishedExternalKnowledgeBase = useAppSelector(getHasPublishedExternalKnowledgeBase);

  if (!onKnowledgeBaseInsertContent || !hasPublishedExternalKnowledgeBase) {
    return null;
  }

  const trackOnInsert = (data: KnowledgeBaseComposerDropdownInsertTrackingData) =>
    trackInterfaceEvent(InterfaceEventsEnum.KNOWLEDGE_BASE_ARTICLE_INSERT, data);

  return (
    <PopoverCoordinator
      renderButton={(isOpen) => renderButton(isOpen)}
      renderModal={(modalProps) =>
        renderDropdown(modalProps, props.panelId, onKnowledgeBaseInsertContent, trackOnInsert)
      }
    />
  );
};

/*
 * Button + Dropdown.
 */

function renderButton(isOpen: boolean) {
  return (
    <UserThemeConsumer>
      {(theme) => (
        <ToolbarButton
          interactionId="knowledge-base-toolbar-button"
          hasHover={isOpen}
          iconName="knowledgeBase"
          label={<Trans id="composer-tool-bar-button-knowledge-base">Knowledge base</Trans>}
          color={theme.greys.shade80}
          hoverColor={theme.greys.shade80}
        />
      )}
    </UserThemeConsumer>
  );
}

function renderDropdown(
  modalProps: PopoverTransferProps,
  panelId: NewPanelId,
  onKnowledgeBaseInsertContent: KnowledgeBaseInsertHandler,
  trackOnInsert: (data: KnowledgeBaseComposerDropdownInsertTrackingData) => void,
) {
  return (
    <KnowledgeBaseComposerDropdownContainer
      {...modalProps}
      isQuickInsert={false}
      onKnowledgeBaseInsertContent={onKnowledgeBaseInsertContent}
      trackOnInsert={trackOnInsert}
      panelId={panelId}
    />
  );
}
